import React, {useRef, useState} from "react";
import {Alert, Button, Form, FormControl, FormGroup, FormLabel, Modal} from "react-bootstrap";
import useCallBackend from "../../hooks/use-call-backend";
import {RejectActivationRequest, RejectActivationResponse} from "../../modal/reject-activation-objects";
import Error from "../../common/error";
import Loading from "../../common/loading";
const RejectRequest:React.FC<{requestId: number | null, resetView: () => void}> = (props) => {
    const {isLoading, error, invokeBackend} = useCallBackend();
    const [isRejected, setIsRejected] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const reasonRef = useRef<HTMLInputElement>(null);


    const handleShowRejectModal = () => {
        setShowRejectModal(true);
    }

    const handleHideRejectModal = () => {
        if(isLoading){
            alert("Please wait for request to complete.");
            return;
        }else if(isRejected){
            props.resetView();
        }

        setShowRejectModal(false);
    }

    const handleResponse = (rejectResponse: RejectActivationResponse) => {
        if(rejectResponse){
            setIsRejected(true);
        }
    }

    const handleSubmitRejection = (event:React.FormEvent) => {
        event.preventDefault();
        console.log('Submitting form....');

        // @ts-ignore
        const reason = reasonRef.current.value;

        if(props.requestId === null || reason === null){
            alert("Could not get request details.");
            return;
        }

        const rejectRequest:RejectActivationRequest = {
            id: props.requestId,
            reason: reason
        };

        invokeBackend({url: "/api/vapActivation/rejectRequest", method: "POST", body: JSON.stringify(rejectRequest)}, handleResponse);
    }

    const rejectForm = (
        <Form onSubmit={handleSubmitRejection}>
            <FormGroup className="mb-3">
                <FormLabel>Reason:</FormLabel>
                <FormControl type="text" placeholder="Enter reason" maxLength={200} required ref={reasonRef} />
            </FormGroup>
            <Button type="submit" variant="primary">Submit</Button>
        </Form>
    );

    return (
        <React.Fragment>
            <Button type="button" variant="danger" onClick={handleShowRejectModal}>Reject</Button>
            <Modal show={showRejectModal} onHide={handleHideRejectModal} backdrop="static" animation={false}>
                <Modal.Header className="bg-light" closeButton>Reject Request:</Modal.Header>
                <Modal.Body>
                    {isLoading && <Loading />}
                    {!isLoading && error && <Error message={error} />}
                    {!isLoading && !isRejected && rejectForm}
                    {isRejected && <Alert variant="success">Done...</Alert>}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
}

export default RejectRequest;